import { useEffect, useState } from "react";
import { Card } from "./../../components/card/card.jsx";
import DateTimeFormat from "../../components/dateFormater/dateFormat2.js";
import { Link } from "react-router-dom";
import ModalNew from "./modalNew.jsx";
import ModalEventTel1Qr from "./modalEventTel1Qr.jsx";
import ModalDeleteEvent from "./modalDeleteEvent.jsx";
import { dataTel1DeleteEvt, dataTel1GetList } from "../../config/apiSPA.js";
import Pagination2 from "../../components/pagination/pagination2.jsx";
const initialContent = {
  current_page: "",
  data: [],
  first_page_url: "",
  from: "",
  last_page: "",
  last_page_url: "",
  links: [],
  next_page_url: "",
  path: "",
  per_page: 3,
  prev_page_url: "",
  to: "",
  total: "",
};
function TrainingEvaluationData() {
  const [eventList, setEventList] = useState([]);
  const [paginate, setPaginate] = useState(initialContent);
  const [searchValue, setSearchValue] = useState("");
  const [newEventModal, setNewEventModal] = useState(false);
  const [statusModalNewEvent, setStatusModalNewEvent] = useState(false);
  const [modalEventQr, setModalEventQr] = useState({ status: false, data: null });
  const [modalDelete, setModalDelete] = useState({ status: false, data: null });

  const loadData = (data) => {
    setEventList(data.content.data);
    setPaginate(data.content);
  };
  function handleClickDeleteEvent(val) {
    setModalDelete({ status: true, data: val });
  }

  function handleClickConfirmEventDelete(val) {
    setModalDelete((a) => ({ ...a, status: false }));
    dataTel1DeleteEvt(val.id).then((res) => {
      if (res.status === "true") {
        dataTel1GetList(searchValue).then((res) => loadData(res));
      }
    });
  }
  function handleNextClickPaginate() {
    if (paginate.current_page < paginate.last_page) dataTel1GetList(searchValue, paginate.current_page + 1).then((res) => loadData(res));
  }
  function handlePrevClickPaginate() {
    if (paginate.current_page > 0) dataTel1GetList(searchValue, paginate.current_page - 1).then((res) => loadData(res));
  }
  function handleSearchSubmit(e) {
    e.preventDefault();
    dataTel1GetList(searchValue).then((res) => loadData(res));
  }

  function handleNewEvent() {
    setNewEventModal(true);
  }

  function handleStatusNewEventModal(val) {
    setStatusModalNewEvent(val);
  }

  function handleClickQrLink(val) {
    setModalEventQr((a) => ({ ...a, status: true, data: val }));
  }
  useEffect(() => {
    if (statusModalNewEvent) {
      dataTel1GetList().then((res) => loadData(res));
    }
  }, [statusModalNewEvent]);
  useEffect(() => {
    dataTel1GetList().then((res) => loadData(res));
  }, []);
  return (
    <>
      <div>
        <div className="d-flex align-items-center mb-3">
          <div>
            <ul className="breadcrumb">
              <li className="breadcrumb-item">
                <a href="#/">Training Evaluation</a>
              </li>
              <li className="breadcrumb-item active">Event</li>
            </ul>

            <h1 className="page-header">
              Training Evaluation Level 1 <small></small>
            </h1>
          </div>

          <div className="ms-auto">
            <a href="#/" onClick={handleNewEvent} className="btn btn-outline-theme">
              <i className="fa fa-plus-circle fa-fw me-1"></i> New
            </a>
          </div>
        </div>

        <hr className="mb-1" />

        <div className="p-3">
          <p className="small mb-3">
            Training Evaluation Level 1 (Reaction), conducted <strong>immediately after training</strong> to measure participant reactions to <strong>materials, instructors, facilities, and overall training</strong>.
          </p>

          <div className="mb-2">
            <strong>Evaluator:</strong>
            <div className="small text-muted">Training participants</div>
          </div>

          <div className="mb-2">
            <strong>Submission:</strong>
            <ul className="small text-muted mb-1 ps-3">
              <li>Instructor or Training Organizer (SFP Dept. HO / HRG Jobsite)</li>
              <li>Learning System & Development Section</li>
              <li>HRG Jobsite (for recap and submission)</li>
            </ul>
          </div>

          <div>
            <strong>Tools:</strong>
            <ul className="small text-muted mb-1 ps-3">
              <li>Form SFP/09/F-005</li>
              {/* <li>E-People Development Platform</li> */}
            </ul>
          </div>
        </div>
        <Card>
          <div className="tab-content p-4">
            {/* ----------------All Tab------------------------------------------------------------------ */}
            <div className="tab-pane fade show active" id="allTab">
              <form onSubmit={(e) => handleSearchSubmit(e)}>
                <div className="input-group mb-4">
                  <div className="d-flex justify-content-end">
                    <div className="input-group">
                      <input onChange={(val) => setSearchValue(val.target.value)} type="text" className="form-control px-35px" placeholder="Search" />
                      <div className="input-group-text position-absolute top-0 bottom-0 bg-none border-0 start-0" style={{ zIndex: 1020 }}>
                        <i className="fa fa-search opacity-5"></i>
                      </div>
                    </div>
                  </div>
                  <button className="btn btn-outline-default" type="submit">
                    <i className="fas fa-search"></i>
                  </button>
                </div>
              </form>

              {/* ----------------Table-------------- */}

              <div className="table-responsive">
                <table className="table table-hover text-nowrap">
                  <thead>
                    <tr>
                      <th className="border-top-0 pt-0 pb-2">No.</th>
                      <th className="border-top-0 pt-0 pb-2">Title</th>
                      <th className="border-top-0 pt-0 pb-2">Institution</th>
                      <th className="border-top-0 pt-0 pb-2">Created by</th>
                      <th className="border-top-0 pt-0 pb-2">Created at</th>
                      <th className="border-top-0 pt-0 pb-2">Valid Until</th>
                      <th className="border-top-0 pt-0 pb-2"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {eventList.length > 0 ? (
                      eventList.map((val, index) => (
                        <tr key={index}>
                          <td className="align-middle">{index + 1}</td>
                          <td className="align-middle">
                            <Link to={"/training-evaluation/result-list/" + val.id}>{val.title}</Link>
                          </td>
                          <td className="align-middle">{val.institution}</td>
                          <td className="align-middle">{val.createdBy}</td>
                          <td className="align-middle">{DateTimeFormat(val.createdAt)}</td>
                          <td className="align-middle">{DateTimeFormat(val.validUntil)}</td>
                          <td className="align-middle">
                            <a onClick={() => handleClickQrLink(val)} href="#/">
                              <i className="fas fa-link"></i>
                            </a>
                            <a onClick={() => handleClickDeleteEvent(val)} href="#/" className="mx-2">
                              <i className="text-danger fas fa-trash"></i>
                            </a>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td></td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              {/* ----------------End Table-------------- */}
            </div>
            <Pagination2 pageInfo={paginate} nextClick={handleNextClickPaginate} prevClick={handlePrevClickPaginate} />
            {/* ----------------End All Tab------------------------------------------------------------------ */}
          </div>
        </Card>
      </div>
      <ModalNew show={newEventModal} statusModal={(val) => handleStatusNewEventModal(val)} onHideModal={() => setNewEventModal(false)} />
      <ModalEventTel1Qr show={modalEventQr.status} data={modalEventQr.data} submitClick={() => setModalEventQr((a) => ({ ...a, status: false }))} onHide={() => setModalEventQr((a) => ({ ...a, status: false }))} />
      <ModalDeleteEvent show={modalDelete.status} data={modalDelete.data} submitClick={(val) => handleClickConfirmEventDelete(val)} onHide={() => setModalDelete((a) => ({ ...a, status: false }))} />
    </>
  );
}

export default TrainingEvaluationData;
